"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMidAccessToken = void 0;
var _constants = require("../publicAPI/constants");
var _Mid = require("../services/AuthStrategy/Mid2");
const getMidAccessToken = () => _Mid.midStorage.getItem(_constants.COMMON_CONSTANTS.MID_ACCESS_TOKEN_KEY);
exports.getMidAccessToken = getMidAccessToken;